




















import { Component, Vue } from "vue-property-decorator";

@Component
export default class Settings extends Vue {
  keys = ["machine", "cutters", "materials", "calculators", "optimizations"];
  download() {
    const data = this.keys.reduce(
      (acc, key) => ({ ...acc, [key]: localStorage.getItem(key) }),
      {}
    );

    this.downloadAsFile(
      JSON.stringify(data),
      "feeds-and-speeds.json",
      "text/plain"
    );
  }

  downloadAsFile(content: string, fileName: string, contentType: string) {
    const a = document.createElement("a");
    const file = new Blob([content], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  clear() {
    for (const key of this.keys) {
      localStorage.removeItem(key);
    }
  }

  upload() {
    console.log("nada");
  }
}
